module.exports = __webpack_public_path__ + "/505d3b55f8d090318ae02ba72d3795c4.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/clouds_oracle.svg
 ** module id = 1623
 ** module chunks = 0
 **/